
function Contact(){
    return (
        <div style={{height: "90vh"}}>
        <h4 class = "p-4">Let's Connect!</h4>
        <p class = "p-2">Feel free to reach out if you're looking for a developer, have a question, or just want to connect.</p>
        <a href="https://www.linkedin.com/in/silviya-s-frontenddev/" rel="noreferrer"  target="_blank" class="me-4 text-reset">
      <i class="bi bi-linkedin fa-lg m-3 black-color"></i>  
      </a>
      <a href="https://github.com/SilviyaS"  rel="noreferrer"  target="_blank" class="me-4 text-reset">
      <i class="bi bi-github fa-lg m-3 black-color"></i>
      </a>
      <a href="https://medium.com/@silviyafrontenddev" rel="noreferrer"  target="_blank"  class="me-4 text-reset">
      <i class="bi bi-medium fa-lg m-3 black-color"></i>
            </a>
      <a href="https://twitter.com/20ec_s" rel="noreferrer"  target="_blank" class="me-4 text-reset">
      <i class="bi bi-twitter fa-lg m-3 black-color"></i>
            </a>
      <a href="https://mail.google.com/mail/u/0/?tab=rm&ogbl#inbox?compose=GTvVlcRzDDMSRvCgmFnVRXqjhhqKFmfpXShbfGVgKtpKgdMFnrfJKMjMNWmjBsFmZNhPHldptVvbg"  rel="noreferrer"  target="_blank" class="me-4 text-reset">
      <i class="bi bi-envelope fa-lg m-3 black-color"></i>
            </a>
        </div>
    )
}

export default Contact;